<template>
  <nav v-if="breadcrumbs.length" aria-label="Breadcrumb" class="text-xs sm:text-sm text-gray-500">
    <ol class="flex flex-wrap items-center gap-y-1 max-w-full">
      <li class="flex items-center">
        <RouterLink to="/" class="hover:text-gray-700">홈</RouterLink>
      </li>
      <li
        v-for="(item, index) in breadcrumbs"
        :key="`${item.to}-${index}`"
        class="flex items-center min-w-0"
      >
        <ChevronRightIcon class="w-4 h-4 mx-1 text-gray-400" />
        <span
          v-if="index === breadcrumbs.length - 1 || !item.to"
          class="text-gray-700 font-medium break-words"
        >
          {{ item.label }}
        </span>
        <RouterLink
          v-else
          :to="item.to"
          class="hover:text-gray-700 break-words"
        >
          {{ item.label }}
        </RouterLink>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter, RouterLink } from 'vue-router'
import { ChevronRightIcon } from '@heroicons/vue/24/outline'
import { useBreadcrumbStore } from '@/stores/breadcrumbs'

const route = useRoute()
const router = useRouter()
const breadcrumbStore = useBreadcrumbStore()

type BreadcrumbItem = {
  label: string
  to?: string
  dynamic?: boolean
  dynamicKey?: string
}

const breadcrumbs = computed(() => {
  const custom = route.meta?.breadcrumbs as BreadcrumbItem[] | undefined
  if (custom && custom.length > 0) {
    return custom.map((item) => {
      if (item.dynamic) {
        const key = item.dynamicKey || String(route.name || '')
        const label = breadcrumbStore.labels[key] || item.label
        return { label, to: item.to }
      }
      return { label: item.label, to: item.to }
    })
  }

  return route.matched
    .filter((record) => record.meta?.title || record.meta?.breadcrumbLabel)
    .filter((record) => record.path !== '' && record.path !== '/')
    .map((record) => {
      const label = (record.meta?.breadcrumbLabel || record.meta?.title) as string
      let to = record.path
      if (record.name) {
        try {
          to = router.resolve({ name: record.name, params: route.params }).path
        } catch (error) {
          to = record.path
        }
      }
      if (!to.startsWith('/')) {
        to = `/${to}`
      }
      return { label, to }
    })
})
</script>
